<template>
  <tr-dialog
    ref="modal"
    name="boleto-payin-entry-details-dialog"
    :hide-cancel-button="true"
    :has-its-own-buttons="true"
    :title="payer.name"
    :width="540"
    :min-width="540"
  >
    <div>
      <div class="row">
        <tr-pill
          class="col-xs-6"
          color="blue"
        >
          Pagador
        </tr-pill>
      </div>
      <div class="row">
        <tr-read-only-text-field
          label="Nome do pagador"
          :value="payer.name"
        />
      </div>
      <div class="row">
        <tr-read-only-text-field
          label="Documento (CPF/CNPJ)"
          :value="cpfCnpj"
        >
          <span>{{ cpfCnpj }}</span>
          <copy-clipboard-button
            v-if="cpfCnpj"
            type="inline"
            :text-to-copy="cpfCnpj"
          />
        </tr-read-only-text-field>
      </div>
      <div class="row">
        <tr-read-only-text-field
          label="Código de barras"
          :value="barcode"
        >
          <span class="barcode">{{ barcode }}</span>
          <copy-clipboard-button
            v-if="barcode"
            type="inline"
            :text-to-copy="barcode"
          />
        </tr-read-only-text-field>
      </div>
      <tr-button
        class="bottom-offset3"
        variant="outlined"
        color="secondary"
        label="Voltar"
        :on-button-click="close"
      />
    </div>
  </tr-dialog>
</template>

<script>
import PersonTypeService from '@transfeeradev/api-services/PersonTypeService';
import CopyClipboardButton from '@/commons/components/container/CopyClipboardButton.vue';

export default {
  name: 'boleto-payin-entry-details-dialog',
  components: {
    CopyClipboardButton
  },
  data: () => ({
    payer: {},
    barcode: ''
  }),
  computed: {
    cpfCnpj() {
      const taxId = this.payer.tax_id;
      if (!taxId) {
        return '';
      }

      return PersonTypeService.format(taxId);
    }
  },
  methods: {
    open(payer, barcode) {
      this.payer = payer || {};
      this.barcode = barcode || '';
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    }
  }
};
</script>

<style scoped>
.barcode {
  word-break: break-all;
}
</style>
